// 切換語言彈窗
import { useTranslation } from 'react-i18next';

import { usePathname } from 'next/navigation';
import { useRouter } from 'next/navigation';
import i18nConfig from '@/i18nConfig';

const ToggleLanguageModal = ({ dispatch, setShowLanguageModal, locale }) => {
    const { t, i18n } = useTranslation();
    const currentLocale = i18n.language;
    const router = useRouter();
    const pathname = usePathname();

    // 預設樣式
    const defaultStyle = 'text-white bg-bou border-bou cursor-default';
    // hover樣式
    const hoverStyle =
        'bg-white text-black9 border-[rgba(199,199,199,.4)] hover:bg-bou hover:text-white hover:border-bou';

    // 語言切換
    const onLocaleChange = (language) => {
        if (language === locale) return;

        // 設定 cookie
        const days = 30;
        const date = new Date();
        date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
        const expires = date.toUTCString();
        document.cookie = `NEXT_LOCALE=${language};expires=${expires};path=/`;

        // 處理跳轉
        if (currentLocale === i18nConfig.defaultLocale && !i18nConfig.prefixDefault) {
            router.push('/' + language + pathname);
        } else if (pathname.includes(`/${currentLocale}`)) {
            router.push(pathname.replace(`/${currentLocale}`, `/${language}`));
        } else {
            router.push(`/${language}${pathname}`);
        }

        router.refresh();
        dispatch(setShowLanguageModal(false));
    };

    return (
        <div className="modal">
            <div
                className="w-[266px] rounded-[12px] bg-white px-[8px] py-[20px] text-center space-y-[22px]
            [&>button]:text-btn1 [&>button]:rounded-[6px] [&>button]:w-[220px] [&>button]:mx-auto [&>button]:block
            [&>button]:py-[15px] [&>button]:trans [&>button]:border-1 border-1 border-black1"
            >
                <p className="text-h5 text-black">{t('TITLE_LANGUAGE')}</p>
                <hr className="border-dashed w-full border-black2 border-0 border-t-1" />

                <button
                    onClick={() => onLocaleChange('tw')}
                    className={`border-1 ${locale === 'tw' ? defaultStyle : hoverStyle}`}
                >
                    繁體中文
                </button>

                <button
                    onClick={() => onLocaleChange('cn')}
                    className={`border-1 ${locale === 'cn' ? defaultStyle : hoverStyle}`}
                >
                    简体中文
                </button>
            </div>

            {/* 關閉用彈窗 */}
            <div className="close-bg" onClick={() => dispatch(setShowLanguageModal(false))} />
        </div>
    );
};

export default ToggleLanguageModal;
